import { c as _c } from "react/compiler-runtime";
import React from 'react';
import LabeledSelectBox from 'components/consumer/LabeledSelectBox';
import MobileOnly from 'components/consumer/MobileOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import { SORT_ORDER_TO_ALGOLIA_INDEX, ALGOLIA_INDEX_TO_SORT_ORDER } from 'commons/constants';
const ProductListingSortBy = t0 => {
  const $ = _c(15);
  const {
    sortByOptions: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sortByOptions = t2;
  const {
    currentProductIndex,
    updateCurrentProductIndex
  } = useAdvancedSearchContext();
  let t3;
  if ($[2] !== updateCurrentProductIndex) {
    t3 = e => {
      const updatedValue = e?.target?.value;
      updateCurrentProductIndex(SORT_ORDER_TO_ALGOLIA_INDEX?.[updatedValue] ?? SORT_ORDER_TO_ALGOLIA_INDEX.featured);
    };
    $[2] = updateCurrentProductIndex;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleChange = t3;
  const t4 = ALGOLIA_INDEX_TO_SORT_ORDER[currentProductIndex];
  let t5;
  if ($[4] !== handleChange || $[5] !== sortByOptions || $[6] !== t4) {
    t5 = <MobileOnly><LabeledSelectBox className="md:hidden" label="Sort by" options={sortByOptions} value={t4} showBlankOption={false} showSingleLineLabelOverlay={true} noMargin={true} size="xs" onChange={handleChange} /></MobileOnly>;
    $[4] = handleChange;
    $[5] = sortByOptions;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = ALGOLIA_INDEX_TO_SORT_ORDER[currentProductIndex];
  let t7;
  if ($[8] !== handleChange || $[9] !== sortByOptions || $[10] !== t6) {
    t7 = <TabletAndDesktopOnly><LabeledSelectBox className="max-[767px]:hidden" label="Sort by" options={sortByOptions} value={t6} showBlankOption={false} showSingleLineLabelOverlay={true} noMargin={true} size="sm" onChange={handleChange} /></TabletAndDesktopOnly>;
    $[8] = handleChange;
    $[9] = sortByOptions;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="w-full max-w-[215px] md:min-w-[16rem]">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default ProductListingSortBy;